"use client";

import { useEffect, useState } from "react";
import style from "./page-loader.module.scss";
import clsx from "clsx";

const PageLoader = () => {
     const [isLoading, setIsLoading] = useState(true);

     useEffect(() => {
          const timer = setTimeout(() => {
               setIsLoading(false);
          }, 1000);

          return () => clearTimeout(timer);
     }, []);

     return (
          isLoading && (
               <main className={clsx(style.page_loader)}>
                    <div className={style.loader}></div>
               </main>
          )
     );
};

export default PageLoader;
